import { render, staticRenderFns } from "./JumpLinks.vue?vue&type=template&id=6c5c12c6&scoped=true&"
import script from "./JumpLinks.vue?vue&type=script&setup=true&lang=ts&"
export * from "./JumpLinks.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5c12c6",
  null
  
)

export default component.exports